module.exports = __webpack_public_path__ + "a8792cc1ec01c86fe0a1f463c6f7dac7.svg";